import { getLink } from '../../../../utils/utils';

import author from './author';

const cite1Text = (
  `Тихо Браге умер на королевском пиру от разрыва мочевого пузыря`
)
const cite1 = (
  `<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">[1]</a></acronym></sup>`
)

const content = {
	rus: (
		`
		<div style="text-align: justify;">
			
			<p class="mb-3 text-end" style="font-size:90%">
				<span class="italic">Не очень серьёзное рассуждение о книжных штампах ХIХ века. 
				В последующих веках книг уже не пишут</span> 😄
			</p>
			
			<p class="mb-3">
				Кто такие «книжные люди»? 
				Это люди, живущие только в книжках; внешне имитирующие живых, настоящих людей, но на деле – пустые макеты, отражающие лишь некоторые, немногие черты живых. 
				В огромном потоке литературы их 99, 999…%; и читатели, которые в той же пропорции частичные, ненастоящие люди с ограниченной памятью, 
				ограниченным воображением и ограниченными мыслительными способностями, воспринимают их как живых, т.е., таких же, как они сами. 
				Бесплотные тени встречаются с бесплотными тенями и видят в них своё отражение. 
				Всё в порядке, все довольны.
			</p>
			
			<p class="mb-3">
				Ложь в книгах совершенно естественно подпитывает ложь жизни,и люди с младенчества, с рождения живут в атмосфере лжи, как рыбы в воде, 
				не зная другого субстрата. 
				Чужие знания, чужие мысли заполняют их мозг, не оставляя места для своих; способность даже не <b>мыслить</b>, а просто <b>воспринимать</b> окружающее непосредственно, 
				через себя, а не через навязанные рамки, подавляется с пелёнок. 
			</p>
			
			<p class="mb-3">
				«Солнце в полдень стоит в зените». 
				Да посмотрите же наверх! 
				Оно в зените только в определённых географических местах; у вас оно сбоку от зенита! 
				Это высчитывается, определяется и описывается в специальных трудах; но кто же станет их читать и понимать! 
				Сказано: «Точно над головой!»; - и хотя можно проверить, подняв голову и увидев, но никто не поднимет. 
				Общее мнение всегда вытеснит собственное в слабом, недалёком мозгу.
			</p>
			
			<p class="mb-3">
				«Жарче всего в полдень». 
				Да в любом дневном графике температуры можно увидеть то, что мы сами чувствуем каждый летний день: жарче всего в 3 часа дня, т.е. 
				в настоящий <b>полдень</b>, если считать день от 12 до 6 часов, когда солнце уже успело подняться и постоять наверху, нагревая землю, 
				и теперь тепло поднимается и от земли, от раскалённых мостовых и домов. 
				Но «жарче всего в полдень, когда солнце стоит над головой»!
			</p>
			
			<p class="mb-3">
				Это очевидные примеры. 
				Я не говорю о психологии человеческих отношений: «толстые обычно добродушны», «мясоеды агрессивнее вегетарианцев» и пр., пр., пр. 
				Мы живём в мире лжи, обмана, застилающего нам глаза, окутывающего серой пеленой, - и это появилось намного раньше т.н. 
				«фейковых новостей» и откровенной лжи, которая сейчас бушует во всех СМИ. 
				Просто с развитием техники стала доступной возможность охватывать более широкую публику – так почему же ею не воспользоваться? 
				Просто расползается то, чего больше не ограничивают, чему дали волю расползаться. 
				С уничтожением науки и дисциплины научного, да и вообще логического мышления, его место занимает клиповое: «только что сказали», 
				а через минуту сказали ещё что-то, и предыдущее забылось, и всё смешалось, и нет никаких оценочных критериев, и нет памяти…
			</p>
			
			<p class="mb-5">
				Кого-то вбомбили в каменный век? 
				Да нас всех вбомбили в интернет-мобильный век, который, в принципе, ничем не лучше. 
				Согнувшаяся над своим «телефоном» особь, у которой единственный рабочий орган – тыкающий палец? 
				Это уже не будущее, это настоящее. 
				Получите, распишитесь… 
			</p>
			
			
			<p class=" text-center mb-5">* * *</p>
			
				
			<p class="mb-3">
				Да, но всё же – о «книжных людях» с которых мы начинали. 
				Каковы же их отличительные особенности? 
			</p>
			
			<p class="mb-3">
				О, их много! 
				Ну, например, самая распространённая: они не имеют естественных отправлений. 
				Проще говоря, не писяют и не какают. 
				Сколько в мировой литературе душераздирающих описаний, как человек прячется где угодно: в комнате, где находятся другие люди (за портьерой, в шкафу…), 
				в закрытом помещении, в транспортном средстве… И все они находятся там долго, бесконечно долго… часами, а то и днями. 
				А человек мочится каждые несколько часов (в среднем, 8 раз в сутки). 
				И выдаст его не дыхание, не шевеление – всё это можно превозмочь силой воли -, а вот задержать надолго мочеиспускание невозможно${cite1}, 
				и выдаст человека зловонная жёлтая струя, которая обязательно появится через несколько часов.
			</p>
			
			<p class="mb-3">
				Но у живого человека. 
				У книжного – никогда.
			</p>
			
			<p class="mb-3">
				Ещё признак книжного человека – состав семьи. 
				Обычно он единственный ребёнок в семье, если не нужно рассказывать о его взаимоотношениях с сибсами, чаще всего с одним, 
				с которым идёт вражда или хоть соперничество (для оттенения некоторых черт характера). 
				Или же это помощник, наперсник, живая тень – для тех же целей. 
				А в те времена в семьях было по десятку детей, - но на что они книжному человеку? 
				Нет, лучше всего, чтобы он был один и рос в безвоздушном пространстве. 
				Батюшка да матушка ещё могут влиять – но больше уж никто!
			</p>
			
			<p class="mb-3">
				Я читала дневник Дружинина: он почти каждый день ходил к проституткам, и это было вполне естественно для его времени и среды. 
				Но как невинны все благородные герои, вступающие в брак к 40 годам или ещё позже! 
				А чем же они занимались всю молодость?
			</p>
			
			<p class="mb-3">
				В браке героя обычно тоже рождается один ребёнок. 
				Если это девочка – она точная копия своей рано умершей матери, что ранит и радует сердце одинокого отца 
				(отец обычно во второй брак не вступает и воспитывает ребёнка сам 😄). 
				Мальчик же обычно на этого отца и похож. 
				Девочек, похожих на отца, и мальчиков, похожих на мать, в книгах не бывает. 
				
			</p>
			
			<p class="mb-3">
				Возьмем пример реального писателя, Теодора Драйзера. 
				Он пишет про финансиста Каупервуда и показывает его как гениального финансиста; всё остальное автора не интересует. 
				К. имел много любовниц, но никого не оплодотворил. 
				Вряд ли это было возможно полтора века назад: контрацептивы тогда не были распространены, и наверняка хоть кто-то забеременел, потребовал поддержки, 
				возможно шантажировал богатого любовника… 
				Но зачем это автору; он ведь создаёт идеальный образ финансиста, а не человека. 
				У К. есть два ребёнка от первой жены; но К. даже не упоминает о них, хотя люди обычно собирают богатство для детей, чтобы род их продолжался и процветал. 
				У матери третьей жены тоже два ребёнка, но она занята только дочерью, хотя, опять-таки обычно, все надежды в Х1Х веке возлагались только на сына 
				(дочь выдавали замуж, и она становилась частью другой семьи). 
				
			</p>
			
			<p class="mb-3">
				Всё это, конечно, относится к литературе ХIХ века; в ХХ или тем более ХХI в. литературы уже нет; по крайней мере, в том виде, в котором она была раньше. 
				Старые шаблоны разрушены; новые ещё не установились, и сей опус явл. только шуткой, не имеющей никакого практичского смысла: зачем смеяться над тем, что уже отошло! 
				Так, безделка… 
			</p>

		</div>
		`
	)
}

const itemName = {
	rus: `О книжных людях`
}

const itemDate = {
	rus: `Июль 2023`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemContent: content.rus,
		itemDate: itemDate.rus,
		itemAuthor: author.rus
	}
}

export default item;